module.exports = __webpack_public_path__ + "img/9788954616621.cf07603d.jpg";